export default __webpack_public_path__ + "src/assets/web3-default.eb4a063dc3a2b520c357bd624e8e0cf3.svg";